import { createAction } from 'redux-act';

export const PREFERENCES_SET_LOCALE = createAction('PREFERENCES_SET_LOCALE');

export const COLLAPSE_MENU = createAction('COLLAPSE_MENU');
export const COLLAPSE_TOGGLE = createAction('COLLAPSE_TOGGLE');
export const CHANGE_LAYOUT = createAction('CHANGE_LAYOUT');
export const NAV_CONTENT_LEAVE = createAction('NAV_CONTENT_LEAVE');
export const NAV_COLLAPSE_LEAVE = createAction('NAV_COLLAPSE_LEAVE');

export const setUserLocale = locale => dispatch => dispatch(PREFERENCES_SET_LOCALE({ locale }));

export const collapseMenuAction = () => dispatch => dispatch(COLLAPSE_MENU());

export const collapseToggle = (payload) => dispatch =>  dispatch(COLLAPSE_TOGGLE(payload));

export const changeLayout = (payload) => dispatch => dispatch(CHANGE_LAYOUT(payload));

export const navContentLeave = () => dispatch => dispatch(NAV_CONTENT_LEAVE());

export const navCollapseLeave = (payload) => dispatch => dispatch(NAV_COLLAPSE_LEAVE(payload));
